import React, { useState, useEffect } from 'react';
import { FiCalendar, FiClock, FiTrash2, FiSave, FiAlertCircle } from 'react-icons/fi';
import Swal from 'sweetalert2';

const API_URL = 'https://app.thundermaxhome.com/api.php';

export default function BlockedDatesPage() {
  const [blockedDates, setBlockedDates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [blockedForm, setBlockedForm] = useState({
    blocked_date: '',
    reason: 'คิวงานเต็ม'
  });

  useEffect(() => {
    fetchBlockedDates();
  }, []);

  const fetchBlockedDates = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(`${API_URL}?action=get_blocked_dates`);
      const data = await res.json();
      if (data.success) {
        setBlockedDates(data.data || []);
      } else {
        setBlockedDates([]);
      }
    } catch (err) {
      console.error(err);
      Swal.fire('ดึงข้อมูลล้มเหลว', 'ไม่สามารถเชื่อมต่อข้อมูลหลังบ้านได้', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBlockedSubmit = async (e) => {
    e.preventDefault();
    if (!blockedForm.blocked_date) return;
    Swal.fire({ title: 'กำลังบันทึก...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

    try {
      const res = await fetch(`${API_URL}?action=add_blocked_date`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(blockedForm)
      });
      const data = await res.json();

      if (data.success) {
        Swal.fire({ icon: 'success', title: 'ระบุวันเต็มเรียบร้อย!', showConfirmButton: false, timer: 1500 });
        setBlockedForm({ blocked_date: '', reason: 'คิวงานเต็ม' });
        fetchBlockedDates();
      } else {
        throw new Error(data.message);
      }
    } catch (err) {
      Swal.fire('ล้มเหลว', err.message, 'error');
    }
  };

  const handleBlockedDelete = async (id, date) => {
    const confirm = await Swal.fire({
      title: 'ปลดบล็อกคิวเต็ม?',
      text: `คุณแน่ใจว่าต้องการให้วันที่ "${date}" กลับมาว่างให้ลูกค้าจองได้ตามปกติหรือไม่`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      confirmButtonText: 'ปลดล็อกคิวว่าง',
      cancelButtonText: 'ยกเลิก'
    });

    if (confirm.isConfirmed) {
      try {
        const res = await fetch(`${API_URL}?action=delete_blocked_date`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id })
        });
        const data = await res.json();
        if (data.success) {
          Swal.fire('ปลดล็อกคิวสำเร็จ!', '', 'success');
          fetchBlockedDates();
        }
      } catch (err) {
        Swal.fire('ล้มเหลว', 'เกิดข้อผิดพลาด', 'error');
      }
    }
  };

  return (
    <div className="space-y-6 pb-20 animate-fade-in text-gray-800 dark:text-gray-100 font-sans text-left">
      {/* Header */}
      <div>
        <h1 className="text-xl font-black text-gray-850 dark:text-white flex items-center gap-2">
          📅 จัดการวันคิวเต็มของบริษัท (Booking Slots Control)
        </h1>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          กำหนดวันที่คิวติดตั้ง/ล้างแอร์เต็ม เพื่อระบบจองคิวหน้าเว็บหลักจะคำนวณและปิดล็อกไม่ให้ลูกค้าเลือกจองในวันดังกล่าว
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        
        {/* ฝั่งซ้าย: ฟอร์มระบุวันคิวเต็ม */}
        <div className="lg:col-span-1">
          <form onSubmit={handleBlockedSubmit} className="bg-white dark:bg-[#131825] p-5 rounded-2xl border border-gray-200 dark:border-[#1e2330] shadow-sm space-y-4 text-xs">
            <h3 className="text-xs font-bold text-indigo-500 flex items-center gap-2 pb-2 border-b border-gray-100 dark:border-gray-800">
              <FiCalendar /> บล็อกวันที่คิวงานเต็ม
            </h3>
            
            <div>
              <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">เลือกวันที่ต้องการบล็อก</label>
              <input
                type="date"
                required
                value={blockedForm.blocked_date}
                onChange={e => setBlockedForm({ ...blockedForm, blocked_date: e.target.value })}
                className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500 font-mono"
              />
            </div>
            
            <div>
              <label className="block font-bold text-gray-700 dark:text-gray-300 mb-1.5">สาเหตุ / ข้อความแสดงหน้าแรก</label>
              <input
                type="text"
                required
                value={blockedForm.reason}
                onChange={e => setBlockedForm({ ...blockedForm, reason: e.target.value })}
                className="w-full p-2.5 rounded-xl border border-gray-250 dark:border-gray-800 dark:bg-gray-800/60 dark:text-white outline-none focus:ring-1 focus:ring-indigo-500"
                placeholder="เช่น คิวเต็ม, ช่างหยุดเทศกาล"
              />
            </div>
            
            <button 
              type="submit" 
              className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-bold py-2.5 rounded-xl transition flex items-center justify-center gap-1.5 shadow-sm shadow-indigo-500/10"
            >
              <FiSave /> บันทึกปิดวันคิวเต็ม
            </button>
          </form>
        </div>

        {/* ฝั่งขวา: รายชื่อวันที่บล็อกไว้ */}
        <div className="lg:col-span-2 bg-white dark:bg-[#131825] p-5 rounded-2xl border border-gray-200 dark:border-[#1e2330] shadow-sm flex flex-col min-h-[400px]">
          <h3 className="text-xs font-bold text-gray-850 dark:text-white mb-3">
            📅 ตารางวันที่ระบบจองปิดทำงาน (วันคิวเต็ม)
          </h3>

          <div className="flex-grow overflow-auto border border-gray-100 dark:border-gray-800 rounded-xl text-xs custom-scrollbar">
            {isLoading ? (
              <div className="flex justify-center items-center h-full text-indigo-500 font-bold animate-pulse">
                กำลังดึงประวัติวันคิวเต็ม...
              </div>
            ) : blockedDates.length === 0 ? (
              <div className="flex flex-col justify-center items-center h-full text-gray-400 gap-2">
                <FiAlertCircle size={28} />
                <p>เปิดรับงานตามปกติ (ยังไม่มีการระบุวันคิวเต็ม)</p>
              </div>
            ) : (
              <table className="w-full text-left border-collapse">
                <thead className="bg-gray-50 dark:bg-[#1b2132]/40 text-gray-500 dark:text-gray-400 font-bold border-b border-gray-100 dark:border-gray-800 sticky top-0">
                  <tr>
                    <th className="p-3">วันที่ปิดรับคิว</th>
                    <th className="p-3">เหตุผลความขัดข้อง</th>
                    <th className="p-3 text-center w-32">ปลดล็อกคิวว่าง</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                  {blockedDates.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50/50 dark:hover:bg-[#1b2132]/10 transition-colors">
                      <td className="p-3 font-mono font-bold text-red-500">{item.blocked_date}</td>
                      <td className="p-3 font-medium text-gray-700 dark:text-gray-300">{item.reason}</td>
                      <td className="p-3 text-center">
                        <button 
                          onClick={() => handleBlockedDelete(item.id, item.blocked_date)}
                          className="px-2.5 py-1 bg-indigo-500/10 text-indigo-500 rounded-full hover:bg-indigo-500 hover:text-white transition text-[10px] font-bold inline-flex items-center gap-0.5"
                        >
                          <FiTrash2 size={10} /> ปลดล็อก
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}
